import { render, staticRenderFns } from "./ModalDetails3x3.vue?vue&type=template&id=96a48d2c&lang=pug"
import script from "./ModalDetails3x3.vue?vue&type=script&lang=js"
export * from "./ModalDetails3x3.vue?vue&type=script&lang=js"
import style0 from "./ModalDetails3x3.vue?vue&type=style&index=0&id=96a48d2c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports